export function isBotCheck() {
  const userAgent = navigator.userAgent.toLowerCase()
  const bots = ['bot', 'google-inspectiontool', 'slurp', 'baiduspider', 'sogou', 'ia_archiver']
  return bots.some((bot) => userAgent.includes(bot))
}
